<template>
    <modal :show="show" @close="close" :closeOnbackdrop="false">
        <template slot="header"><h3>{{ model.item }}</h3></template>
        <template>
            <div class="row">
                <template v-if="isLoading">
                    <div class="col-md-5">
                        <div class="skeleton-progress progress m-auto" style="width: 100%; height: 16em;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="skeleton-progress progress" style="width: 100%; height: 4em;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                        </div>
                        <div class="skeleton-progress progress" style="width: 100%; height: 4em;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                        </div>
                        <div class="skeleton-progress progress" style="width: 6em; height: 4em;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="col-md-5 text-center">
                        <img :src="model.image" style="max-width: 20em;">
                        <div class="mb-2"><small>*Shown for reference only, actual product may vary.</small></div>
                    </div>
                    <div class="col-md-7">
                        <h3>{{ model.item }}</h3>
                        <p>{{ model.description }}</p>
                        <p class="price">${{ price_format(model.price) }}</p>
                        <input type="number" class="form-control" v-model="model.quantity" min="1" style="width: 5em;">
                        <template v-if="model.stock_status == 'instock'">
                            <p :class="`stock_status instock mt-3`">{{ model.stock }} in stock</p>
                        </template>
                        <template v-else>
                            <p :class="`stock_status ${model.stock_status} mt-3`">{{ stock_status_label }}</p>
                        </template>
                    </div>
                </template>
            </div>
        </template>
        <template slot="footer">
            <button class="btn btn-black" type="button" :disabled="isSubmitting || isLoading" @click="add_to_cart">
                <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                <template v-else>Add To Cart</template>
            </button>
        </template>
    </modal>
</template>
<script>
export default {
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            model: {
                id: '',
                image: '',
                item: '',
                stock: 0,
                stock_status: '',
                description: '',
                price: 0,
                quantity: 1,
                total: 0
            }
        }
    },
    mounted() {
        this.get_spare_part()
    },
    props: {
        id: Number,
        show: Boolean
    },
    computed: {
        stock_status_label() {
            let labels = {
                'instock': 'In stock',
                'outofstock': 'Out of stock',
                'backorder': 'Back Order'
            }

            if(labels[this.model.stock_status]) {
                return labels[this.model.stock_status]
            }

            return false
        }
    },
    methods: {
        get_spare_part() {
            this.isLoading = true
            this.$http.get('/api/spare-parts/' + this.id)
                .then(response => {
                    this.model = response.data.data
                    if(!this.model.image) {
                        this.model.image = '/api/public/img/item-placeholder.png'
                    }
                    this.model.quantity = 1
                    this.model.total = 0
                    this.isLoading = false
                })
        },
        add_to_cart() {
            this.isSubmitting = true
            let cart = localStorage.getItem('cart')
            let total = parseFloat(this.model.price) * parseInt(this.model.quantity)
            this.model.total = total.toFixed(2)

            if(!cart) {
                cart = [this.model]
            } else {
                cart = JSON.parse(cart)
                let exist = false
                for(let x in cart) {
                    if(cart[x].id == this.model.id) {
                        cart[x].price = this.model.price
                        cart[x].quantity = parseInt(this.model.quantity) + parseInt(cart[x].quantity)
                        let total = parseFloat(cart[x].price) * parseInt(cart[x].quantity)
                        cart[x].total = total.toFixed(2)
                        exist = true
                        break
                    }
                }
                if(!exist) {
                    cart.push(this.model)
                }
            }

            localStorage.setItem('cart', JSON.stringify(cart))
            setTimeout(() => { this.isSubmitting = false }, 300)
            setTimeout(() => { this.close() }, 300)
        },
        close() {
            this.show = false
            this.$emit('close', true)
        },
        price_format(num) {
            return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    }
}
</script>
<style lang="scss" scoped>
.modal::v-deep {
    .modal-dialog {
        max-width: 768px;
    }
}
.price {
    color: #4cae4c;
    font-weight: bold;
    font-size: 16px;
}
.stock_status {
    font-size: 12px;
    &.instock {
        color: #4cae4c;
    }
    &.outofstock {
        color: #c90000;
    }
    &.backorder {
        color: #c90000;
    }
}
</style>